module.exports = "<div class=\"main-content\">\n    <div class=\"container-fluid\">\n        <app-list></app-list>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/projects/projects.component.html
// module id = ../../../../../src/app/projects/projects.component.html
// module chunks = main